class BentoMobileSlider extends HTMLElement {
  constructor() {
    super();
    this.grid = this.querySelector('.bento-grid--3');
    this.prevButton = this.querySelector('[data-bento-prev]');
    this.nextButton = this.querySelector('[data-bento-next]');
    this.dotsContainer = this.querySelector('[data-bento-dots]');
    this.mql = window.matchMedia('(max-width: 749px)');

    if (!this.grid) return;

    this.cards = Array.from(this.grid.children);
    this.buildDots();
    this.bindEvents();
    this.update();
  }

  buildDots() {
    if (!this.dotsContainer) return;
    this.dotsContainer.innerHTML = '';
    this.cards.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'bento-slider__dot';
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dot.addEventListener('click', () => this.scrollToIndex(i));
      this.dotsContainer.appendChild(dot);
    });
  }

  bindEvents() {
    if (this.prevButton) this.prevButton.addEventListener('click', () => this.step(-1));
    if (this.nextButton) this.nextButton.addEventListener('click', () => this.step(1));
    this.grid.addEventListener('scroll', () => {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(() => this.update());
    });
    window.addEventListener('resize', () => this.update());
  }

  currentIndex() {
    if (this.cards.length < 2) return 0;
    const offset = this.cards[1].offsetLeft - this.cards[0].offsetLeft;
    if (offset <= 0) return 0;
    return Math.round(this.grid.scrollLeft / offset);
  }

  step(dir) {
    const next = Math.max(0, Math.min(this.cards.length - 1, this.currentIndex() + dir));
    this.scrollToIndex(next);
  }

  scrollToIndex(i) {
    const card = this.cards[i];
    if (!card) return;
    this.grid.scrollTo({ left: card.offsetLeft - this.grid.offsetLeft, behavior: 'smooth' });
  }

  update() {
    const i = this.currentIndex();
    if (this.dotsContainer) {
      Array.from(this.dotsContainer.children).forEach((dot, idx) => {
        const active = idx === i;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }
    if (this.prevButton) this.prevButton.toggleAttribute('disabled', i <= 0);
    if (this.nextButton) this.nextButton.toggleAttribute('disabled', i >= this.cards.length - 1);
  }
}

customElements.define('bento-mobile-slider', BentoMobileSlider);
